var document = require('./_global').document;
module.exports = document && document.documentElement;



//////////////////
// WEBPACK FOOTER
// ./src/frontend-lib/~/core-js/library/modules/_html.js
// module id = DUji
// module chunks = 0